<template>
  <printable>
    <div class="row">
      <div class="col-12" style="font-size: 16px">
        <table>
          <thead>
            <tr >
              <td style="align-content: start;" :colspan="isDODriver && data.qr_url != '' ? 6 : 8">
                <b class="mb-2">
                  <span v-if="isDOSalesman">Sales</span>
                  <span v-if="isDODriver">Driver</span> 
                  DO Accumulative Report By Item {{ data.perusahaan }} 
                </b>
                <p class="mb-0" v-html="detail"></p>
                <span v-if="isDOSalesman">
                  <p class="m-0">SALESMAN : {{ data.salesman }}</p> 
                </span>
                <br v-if="isDOSalesman && isDODriver" />
                <span v-if="data.driver">
                  <p  class="m-0">Driver : {{ data.driver }}</p> 
                </span>
              </td>
              <td v-if="isDODriver && data.qr_url != ''" colspan="2" style="height: 9rem; text-align: center;;" >
                <qrcode-vue :size="120" :value="data.qr_url" />
                <span style="text-transform: lowercase;">{{ data.qr_url }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: none"></td>
            </tr>
            <tr>
              <th
                colspan="2"
                rowspan="2"
                style="vertical-align: middle; text-align: center; !important; width: 60%"
              >
                CODE
              </th>
              <th rowspan="2" style="width: 5%; text-align: center">HARGA</th>
              <th colspan="2">QTY</th>
              <th colspan="3">PENGEMBALIAN</th>
            </tr>
            <tr>
              <th
                style="width: 50px"
                v-for="(cop, i) in ['DUS', 'PCS', '1', '2', '3']"
                :key="i"
                v-html="cop"
              />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: none"></td>
            </tr>
            <template v-for="(row, brand) in data.detail">
              <tr>
                <td colspan="8" style="text-align: left">
                  <strong>GROUP : </strong> {{ brand }}
                </td>
              </tr>
              <template v-for="(val, j) in row">
                <tr>
                  <td>
                    <div class="row">
                      <div class="col-6">{{ val.item_code }}</div>
                      <div class="col-6">{{ val.kode_barang }}</div>
                    </div>
                  </td>
                  <td>
                    {{ val.nama_barang }}
                  </td>
                  <td>
                    {{ val.tipe_harga }}
                  </td>
                  <td class="text-center">{{ val.sum_qty }}</td>
                  <td class="text-center">{{ val.sum_qty_pcs }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </template>
              <tr :key="'total' + brand" class="total">
                <td colspan="3" class="text-left">
                  <strong>SUBTOTAL : </strong>
                </td>
                <td v-html="data.subtotal[brand].sum_qty" />
                <td v-html="data.subtotal[brand].sum_qty_pcs" />
                <td colspan="3" />
              </tr>
              <tr :key="'space' + brand">
                <td style="border: none"></td>
              </tr>
            </template>
            <tr>
              <td style="border: none"></td>
            </tr>
            <tr>
              <td><strong>Nomor DO </strong></td>
              <td colspan="7">
                <div>
                  <span
                    v-for="(inv, i) in data.invoice"
                    v-html="(inv != null ? inv : '') + ',  '"
                    :key="i"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>Total DO </strong></td>
              <td colspan="7">{{ data.invoice.length }} Invoice</td>
            </tr>
            <tr>
              <td style="border: none"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-3 text-center row">
        <div class="col-12"><b>BAG. GUDANG</b></div>
        <div class="col-12" style="height: 50px"></div>
        <div class="col-12">( <span style="margin: 80px"></span> )</div>
      </div>
      <div class="col"></div>
      <div class="col-3 text-center row">
        <div class="col-12"><b>SUPIR</b></div>
        <div class="col-12" style="height: 50px"></div>
        <div class="col-12">( <span style="margin: 80px"></span> )</div>
      </div>
    </div>
    <div class="pagebreak"></div>
    <div class="row">
      <div class="col-12" style="font-size: 16px">
        <table>
          <thead>
            <tr>
              <td colspan="7">
                <b>Rekap Penerimaan Invoice {{ data.perusahaan }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="4" v-html="detail" style="text-align: left" />
              <td rowspan="1" colspan="3" class="text-right">
                <span v-if="isDOSalesman">
                  <b>SALESMAN</b> : {{ data.salesman }}
                </span>
                <span v-if="isDODriver">
                  <b>Driver</b> : {{ data.driver }}
                </span>
              </td>
            </tr>
            <tr>
              <th style="width: 30px" class="text-center">No</th>
              <th class="text-left">No Invoice</th>
              <th class="text-left" style="width: 25%">Kode Outlet</th>
              <th style="width: 25%">Nama Outlet</th>
              <th>Pembayaran</th>
              <th class="text-right" style="width: 15%">Grand Total</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: none"></td>
            </tr>
            <template v-for="(row, i) in data.penjualan">
              <tr :key="i">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ row.no_invoice }}</td>
                <td>{{ row.no_acc }} [{{ row.cust_no }}]</td>
                <td>{{ row.nama_toko }}</td>
                <td class="text-center">{{ row.tipe_pembayaran }}</td>
                <td class="text-right">
                  {{ row.sum_grand_total | currency }}
                </td>
                <td>
                  <div style="min-width: 150px"></div>
                </td>
              </tr>
              <template v-if="_isBreak(i)">
                <tr :key="'total' + row.tipe_pembayaran">
                  <th class="text-left" colspan="5"><strong>TOTAL</strong></th>
                  <th class="text-right">
                    {{ data.grand_total[row.tipe_pembayaran] | currency }}
                  </th>
                  <th></th>
                </tr>
                <tr :key="'space' + row.tipe_pembayaran">
                  <td style="border: none"></td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" style="font-size: 16px">
      <div class="col-3 text-center row">
        <div class="col-12"><b>ADMIN LOGISTIK</b></div>
        <div class="col-12" style="height: 50px"></div>
        <div class="col-12">( <span style="margin: 80px"></span> )</div>
      </div>
      <div class="col-3 text-center row">
        <div class="col-12"><b>PIC GUDANG</b></div>
        <div class="col-12" style="height: 50px"></div>
        <div class="col-12">( <span style="margin: 80px"></span> )</div>
      </div>
      <div class="col"></div>
      <div class="col-3 text-center row">
        <div class="col-12"><b>SUPIR</b></div>
        <div class="col-12" style="height: 50px"></div>
        <div class="col-12">( <span style="margin: 80px"></span> )</div>
      </div>
    </div>
  </printable>
</template>
<script>
import helper from "@/assets/js/helper.js";
import QrcodeVue from "qrcode.vue";

export default {
  name: "PrintInvoice",
  mixins: [helper],
  components: {
      QrcodeVue,
  },

  data() {
    return {
      data: {},
      detail: "",
      detail_headers: ["qty", "qty_pcs"],
    };
  },
  computed: { 
    isDOSalesman(){
      return this.data.salesman != ''
    },
    isDODriver(){
      return this.data.driver != ''
    }
  },

  methods: {
    _isBreak(i) {
      let line_type = this.data.penjualan[i].tipe_pembayaran;
      let next_type = this.data.penjualan[i + 1]
        ? this.data.penjualan[i + 1].tipe_pembayaran
        : "";
      return line_type != next_type;
    },
    getData() {
      let data = JSON.parse(localStorage.rekapitulasiDO);
      this.data = data;
      this.detail =
        "Depo : " +
        data.depo +
        " " +
        "<br/> Periode : " +
        data.start_date +
        " - " +
        data.end_date;
      var formatted_date = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
      document.title = "Rekapitulasi-DO " + formatted_date + " - PRINT";

      // setTimeout(() => {
      //   window.print();
      // }, 500);
    },
  },

  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
th {
  vertical-align: middle;
  text-align: center;
}
td,
th {
  /* text-align: center; */
  text-transform: uppercase;
}
.total {
  font-weight: 1000;
}
.total td {
  text-align: center;
}
@media print {
  .pagebreak {
    page-break-before: always;
  } /* page-break-after works, as well */
}
</style>